import { Component, EventEmitter, Input, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Question } from '../../../models/QuestionResponse';

@Component({
  selector: 'q-quizz',
  standalone: true,
  imports: [],
  templateUrl: './quizz.component.html',
  styleUrl: './quizz.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class QuizzComponent {
  @Input() graphism!: string;
  @Input() question!: Question;
  @Input() pickedAnswers!: string[];
  @Output() pickedAnswersChange = new EventEmitter<string[]>();

  singleSelect: boolean;
  videoUrl: string | null = null;
  showAnswers = false;

  ngOnInit() {
    this.setupQuestion();
    // Show answers after title and image animations
    setTimeout(() => {
      this.showAnswers = true;
    }, 1800); // Title (0.8s) + Image (0.8s) + small buffer
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question']) {
      this.setupQuestion();
      this.showAnswers = false;
      // Show answers after animations
      setTimeout(() => {
        this.showAnswers = true;
      }, 1800);
    }
  }

  setupQuestion() {
    this.videoUrl = null;
    this.singleSelect = this.question.good_answers.filter((elt) => elt === '1').length === 1;

    const url = this.getQuestionVideoUrl();

    if (url !== null) {
      this.videoUrl = url;
    }
  }

  toggleAnswer(index: number) {
    if (this.singleSelect) {
      this.pickedAnswers = this.question.answers.map((elt) => '0');
      this.pickedAnswers[index] = '1';
    } else {
      if (this.pickedAnswers[index] === '0') {
        this.pickedAnswers[index] = '1';
      } else {
        this.pickedAnswers[index] = '0';
      }
    }

    this.pickedAnswersChange.emit(this.pickedAnswers);
  }

  isActive(index: number) {
    return this.pickedAnswers[index] === '1';
  }

  getIllusSrc(): string {
    return this.question.illustration_url ?? '';
  }

  getQuestionVideoUrl(): string | null {
    if (this.question.video_url === null || this.question.video_url === '') {
      return null;
    }

    return this.question.video_url;
  }

  getAnswerAnimationDelay(index: number): string {
    const staggerDelay = 0.2;
    return `${index * staggerDelay}s`;
  }
}
